import { Match, Show, Switch, createEffect, createSignal, onMount, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import { User } from '../../types/shared';
import { UserProfileMenuDesktop } from './user-profile-menu-desktop/user-profile-menu-desktop';
import { UserProfileMenuMobile } from './user-profile-menu-mobile/user-profile-menu-mobile';
import { styled } from 'solid-styled-components';
import { useLocation } from '@solidjs/router';

export const StyledLoginMenu = styled.div`
    container-type: inline-size;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: ${theme.palette.white};
    overflow-y: auto;
    overflow-x: hidden;
`;


export const UserProfileMenu = (props: UserProfileMenuProps) => {
    const { viewport, updateUser, siteInfo, appStore } = useContext(AppContext);
    const [ currentPath, setCurrentPath ] = createSignal<string>('');
    const location = useLocation();

    const { userProfileMenuOpen, closeUserProfileMenu } = appStore;

    const logOut = async () => {
        const response = await fetch('/logout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                siteType: siteInfo.siteType,
            }),
        });
        
        if (response.ok) {
            closeUserProfileMenu();
            updateUser();
        }
    };

    // if user hits esc key, close the login menu
    onMount(() => {
        setCurrentPath(location.pathname);

        if (window) {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    closeUserProfileMenu();
                }
            });
        }
    });

    // if the user navigates to a new page, close the menu
    createEffect(() => {
        if (location.pathname !== currentPath()) {
            setCurrentPath(location.pathname);
            closeUserProfileMenu();
        }
    });

    return (
        <Show when={userProfileMenuOpen()}>
            <StyledLoginMenu>
                <Switch>
                    <Match when={viewport.width > theme.breakpoints.TABLET}>
                        <UserProfileMenuDesktop
                            user={props.user}
                            handleCloseMenuClick={() => closeUserProfileMenu()}
                            handleSignOutClick={() => logOut()}
                        />
                    </Match>
                    <Match when={viewport.width <= theme.breakpoints.TABLET}>
                        <UserProfileMenuMobile
                            user={props.user}
                            handleCloseMenuClick={() => closeUserProfileMenu()}
                            handleSignOutClick={() => logOut()}
                        />
                    </Match>
                </Switch>
            </StyledLoginMenu>
        </Show>
    );
};
export type UserProfileMenuProps = {
    user: User | null;
};
